import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { getImageUrlStatic } from '../../../../utils/utilsFunctions';
import { BlockMargin } from '@service/article/article.service';
import { MarginService } from '../margin.service';

interface GridSectionInterface
{
  type: string,
  blocks: Array<GridItemInterface>
}

interface GridItemInterface
{
  imageLink: string,
  columnFrom: string,
  columnTo: string,
  rowFrom: string,
  rowTo: string
}

@Component({
    selector: 'app-simple-grid',
    templateUrl: './simple-grid.component.html',
    styleUrls: ['./simple-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SimpleGridComponent implements OnInit
{

  @Input() section: GridSectionInterface;
  @Input() margin: BlockMargin;

  getImageUrlStatic = getImageUrlStatic;

  constructor(public changeDet: ChangeDetectorRef, public marginService: MarginService) { }

  ngOnInit(): void
  {
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize($event): void
  {
    this.changeDet.detectChanges();

  }
}
